import { NgForOf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton, MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { Role } from '../../shared/enums/role.enum';
import { UserLevel } from '../../shared/enums/user-level.enum';
import { UserTitle } from '../../shared/enums/user-title.enum';
import { UserModelForm } from '../../shared/models/user/form/user-model.form';
import { UserModelMapper } from '../../shared/models/user/form/user-model.mapper';
import { UserDetails } from '../../shared/models/user/user.model';

@Component({
  selector: 'dnv-user-dialog',
  templateUrl: 'user-dialog.component.html',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatButton,
    TranslatePipe,
    ReactiveFormsModule,
    MatSelect,
    MatOption,
    NgForOf,
  ],
})
export class UserDialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<UserDialogComponent>);
  protected readonly data = inject<UserDetails>(MAT_DIALOG_DATA);

  protected userForm!: FormGroup;
  private readonly userModelMapper = new UserModelMapper(UserModelForm);

  userRoles = Object.keys(Role);
  userLevels = Object.values(UserLevel);
  userTitles = Object.values(UserTitle);

  ngOnInit(): void {
    const userDetails = this.data;
    this.userForm = this.buildUserForm(userDetails || {});
  }

  private buildUserForm(userDetails: Partial<UserDetails>): FormGroup {
    const userModelMapper = new UserModelMapper(UserModelForm);
    return userModelMapper.buildForm(userDetails) as FormGroup;
  }

  public onSave(): void {
    if (this.userForm.valid) {
      this.dialogRef.close(this.userModelMapper.toObject(this.userForm.value));
    }
  }

  public onNoClick(): void {
    this.dialogRef.close(null);
  }

  protected readonly Role = Role;
}
